import { html, type TemplateResult } from 'lit';

import type { SetupView } from '../../types/views';
import type { RequiredField } from './csv-import-setup-body';

import './csv-import-setup-body.js';

// ============================================================================
// Types
// ============================================================================

export interface SetupStepProps {
  selectedFileName: string | null;
  fileErrorMessage: string | null;
  requiredFields: RequiredField[];
  maxFileSize: number;
  maxFileSizeLabel: string;
}

// ============================================================================
// Module-level cached event dispatchers
// ============================================================================

const dispatchNext = (e: Event) => {
  const target = e.target as HTMLElement;
  target.dispatchEvent(
    new CustomEvent('csv-import-next', {
      bubbles: true,
      composed: true,
    }),
  );
};

const dispatchClose = (e: Event) => {
  const target = e.target as HTMLElement;
  target.dispatchEvent(
    new CustomEvent('csv-import-close', {
      bubbles: true,
      composed: true,
      // cancelable: the cancel-confirm spec will call preventDefault()
      // to intercept close and show the confirmation overlay.
      cancelable: true,
    }),
  );
};

// ============================================================================
// Step template function
// ============================================================================

/**
 * Returns the full step template for the Setup step: body + footer buttons.
 * Intended to be rendered inside `<csv-import-modal-shell>`.
 */
export function setupStepTemplate(
  view: SetupView,
  props: SetupStepProps,
): TemplateResult {
  return html`
    <csv-import-setup-body
      slot="step-body"
      .view=${view}
      .selectedFileName=${props.selectedFileName}
      .fileErrorMessage=${props.fileErrorMessage}
      .requiredFields=${props.requiredFields}
      .maxFileSize=${props.maxFileSize}
      max-file-size-label=${props.maxFileSizeLabel}
    ></csv-import-setup-body>
    <inmar-hc-button
      slot="footer"
      label="Next"
      variant="primary"
      ?disabled=${view !== 'file-selected' && view !== 'preview-error'}
      @button-click=${dispatchNext}
    ></inmar-hc-button>
    <inmar-hc-button
      slot="footer"
      label="Cancel"
      variant="tertiary"
      ?disabled=${view === 'processing'}
      @button-click=${dispatchClose}
    ></inmar-hc-button>
  `;
}
